import { useContext } from 'react'

import GeoContext from 'contexts/geoContext'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { OfferPackageOptionView, getCheapestSelectedPackageOption } from 'selectors/offerPage/offerPageSelectors'
import { useAppSelector } from 'hooks/reduxHooks'

export const useOfferPageRate = (state: OfferPageState): OfferPackageOptionView & { isPriceTaxExclusive: boolean } => {
  const { isTaxExclusiveRegion } = useContext(GeoContext)
  const packageView: OfferPackageOptionView = useAppSelector(
    (appState) => getCheapestSelectedPackageOption(appState, state),
  )
  if (!packageView) return

  const exclusivePrice = packageView.hotelPrice
  const inclusivePrice = packageView.hotelPrice + packageView.propertyFees
  return {
    ...packageView,
    hotelPrice: isTaxExclusiveRegion ? packageView.hotelPrice : packageView.hotelPrice + packageView.propertyFees,
    isPriceTaxExclusive: isTaxExclusiveRegion && exclusivePrice !== inclusivePrice,
  }
}
